export default __webpack_public_path__ + "static/media/baseline-settings-20px.985eb55e.svg";